import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { ContactoAseguradoras } from './contacto-aseguradoras.model';

@Injectable({
  providedIn: 'root'
})
export class ContactoAseguradorasService {
  listContactoAse:ContactoAseguradoras[];
  contactoAse:ContactoAseguradoras;
  private routeApi = "AdmAseguradoraRamoTelefonoes"
  constructor(private generalHttp:GeneralHttpService) { }


  getContactoAseguradora(){
    return this.generalHttp.getHttp(this.routeApi).then(r=> this.listContactoAse = r as ContactoAseguradoras[]);
  }

  postContactoAseguradora(form:ContactoAseguradoras){
   return this.generalHttp.postHttp(form,this.routeApi)
  }

  getContactoById(id:number){
   return this.generalHttp.getHttpById(id,this.routeApi).then(r => this.contactoAse = r as ContactoAseguradoras);
  }

  updateContactoAse(form:ContactoAseguradoras,id:number){
    return this.generalHttp.putHttp(form,id,this.routeApi)
  }

  getByRamoInsurance(codeInsurance:string,idBranch:number){
    return this.generalHttp.getHttpById(codeInsurance,this.routeApi + "/ByRamoInsurance/" + idBranch).then(r => this.listContactoAse = r as ContactoAseguradoras[]);
  }

  deleteContactoAse(id:number){
    return this.generalHttp.deleteHttp(id,this.routeApi);
  }

}
